import { Dispatch, FC, SetStateAction, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useCheckDevice } from '../../../hooks/UseCheckDevice';
import { useOutsideClickDetection } from '../../../hooks/UseOutsideClickDetection';
import { AppState } from '../../../store/AppState';
import { CurrentUser } from '../../../types';
import { HelpFormResource } from '../../../types/header/HelpFormResource';
import SupportHelpForm from './SupportHelpForm';
import {
  IconWrapper,
  MobileSupportNumber,
  SupportCloseWrapper,
  SupportContentText,
  SupportContentWrapper,
  SupportHeader,
  SupportHelpWrapper,
  SupportNumberWrapper,
  SupportOrSpan,
  SupportOrWrapper,
  SupportTooltipWrapper,
} from './SupportHelpStyles';

type SupportHelpProps = {
  setIsOpen?: Dispatch<SetStateAction<boolean>>;
  onClose?: () => void;
};

const SupportHelp: FC<SupportHelpProps> = ({ setIsOpen, onClose }) => {
  const currentUser = useSelector<AppState, CurrentUser>((currentUser) => currentUser.currentUser);
  const wrapperRef = useRef<HTMLDivElement>(null);

  const [data, setData] = useState<HelpFormResource>();
  const { isMobileDevice } = useCheckDevice();
  useOutsideClickDetection(wrapperRef, setIsOpen);

  const closeHelp = (): void => {
    if (setIsOpen) {
      setIsOpen(false);
    }

    if (isMobileDevice && onClose) {
      onClose();
    }
  };

  useEffect(() => {
    setData({
      lastName: currentUser.lastName,
      firstName: currentUser.firstName,
      email: currentUser.shadowUserName
        ? currentUser.shadowUserName.replace('@', '%20') + '/' + currentUser.userName
        : currentUser.userName,
      file: undefined,
      message: '',
      phone: '',
    });
  }, [currentUser]);

  return (
    <SupportHelpWrapper data-testid='support-help'>
      <SupportTooltipWrapper isMobileDevice={isMobileDevice} ref={wrapperRef}>
        {!isMobileDevice && (
          <SupportHeader>
            <SupportCloseWrapper onClick={closeHelp} data-testid='close-button'>
              <IconWrapper type='x' fontSize={200}></IconWrapper>
            </SupportCloseWrapper>
            Contact Support
          </SupportHeader>
        )}
        <SupportContentWrapper>
          <SupportContentText isMobileDevice={isMobileDevice}>Call us</SupportContentText>
          <SupportNumberWrapper>
            <IconWrapper type='phone' fontSize={120}></IconWrapper>
            &nbsp;
            {!isMobileDevice ? (
              '1-800-801-0018'
            ) : (
              <MobileSupportNumber href='tel:1-800-801-0018'>1-800-801-0018</MobileSupportNumber>
            )}
          </SupportNumberWrapper>
          <SupportOrWrapper isMobileDevice={isMobileDevice}>
            <SupportOrSpan>&nbsp;</SupportOrSpan>
          </SupportOrWrapper>
          <SupportContentText isMobileDevice={isMobileDevice}>
            {isMobileDevice ? 'Message us' : 'Email us'}
          </SupportContentText>
        </SupportContentWrapper>
        {data && <SupportHelpForm formData={data} closeHelp={closeHelp} />}
      </SupportTooltipWrapper>
    </SupportHelpWrapper>
  );
};

export default SupportHelp;
